import styles from './loader.module.css'
  

function loader() {
  return (
    <div className={styles.loader}></div>
  )
}

export default loader